import React, { useEffect, useState } from 'react';
import BatteryGauge from 'react-battery-gauge'
import { FormattedMessage } from 'react-intl';
import { APIGetLoggerEventsModel } from "models/APIGetLoggerEventsModel";
import moment from 'moment'
import { useMobileContext, useMobileLandscape } from '../../Context/ContextProvider'
// STATE


interface Props {
    eventData: APIGetLoggerEventsModel
    startDate: string | undefined
}
const BatteryInfoDisplay: React.FC<Props> = ({eventData, startDate }) => {
    const [remainingYears, setRemaingYears] = useState<string>("")
    const isMobile = useMobileContext()
    const isLandscape = useMobileLandscape()

    useEffect(() => {
        
        if (moment(startDate).isSameOrAfter(moment().subtract(14, 'days'))) {
            setRemaingYears('calculating...')
        } else if (eventData.remainingBattYears > 15) {
            setRemaingYears('15+')
        } else {
            setRemaingYears(eventData.remainingBattYears.toFixed(2))
        }
        
    }, [eventData])

    const custom = {
        batteryBody: {
            strokeWidth: 2
        },
        batteryCap: {
            strokeWidth: 2
        },
        batteryMeter: {
            fill: '#00BF00',
            lowBatteryValue: 15,
            lowBatteryFill: 'red',
            outerGap: 1,
            noOfCells: 1,
            interCellsGap: 1
        },
        readingText: {
            darkContrastColor: 'black'
        }
    }


    const p = {
        fontSize: isMobile ? '18px': 'inherit'
    } 

    return (
        <div>
            {
                !isMobile ? <h5 style={{ textAlign: "center" }}><b><FormattedMessage id="Battery Info" /></b></h5> :
                    <h3 style={{ textAlign: "center" }}><b><FormattedMessage id="Battery Info" /></b></h3>
        }
        <div>

                <div style={{ width: "100%", display: "flex", marginTop: isLandscape ? "25px" : "-10px" } }>
                    <p style={{ ...p, margin: "6px 10px 0 0", color: eventData.remainingBattPerc < 5 ? 'red' : '#333333'} }><FormattedMessage id="Remaining Battery Percentage"/> *</p>
                {eventData && <BatteryGauge value={eventData.remainingBattPerc < 5 ? 5 : eventData.remainingBattPerc} orientation="horizontal" size={70} animated={true} customization={custom} />}
            </div>
                <div style={{ width: "100%", display: "flex"}}>
                    <p style={{ ...p, textAlign: "center", display: "flex", justifyContent: "center", margin: remainingYears === 'calculating...' ? "6px 20px 0 0" : "6px 54px 0 0" }}><FormattedMessage id="Estimate Years Remaining" /> *</p>
                    {eventData && <h4 style={{ margin: isMobile ? "4px 0 0 8px": "4px 0 15px 0"}}><b>{remainingYears}</b></h4>}
                </div>
            </div>
        </div>
    );
};

export default BatteryInfoDisplay;
